import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import BenefitsLayout, { BenefitPager } from "./BenefitsLayout";
import { benefitDate, benefitError, publicBenefitGet, benefitNumber } from "../../services/customerBenefitsService";

export default function CustomerPoints() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const rawPhone = params.has("phone") || params.has("SDT");
  const [page, setPage] = useState(1);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const sequence = useRef(0);
  useEffect(() => {
    setResult(null); setLoading(false);
    if (!token || rawPhone) return undefined;
    const controller = new AbortController(), current = ++sequence.current;
    setLoading(true); setError(""); setResult(null);
    publicBenefitGet("/api/public/customer-points", { token, page, pageSize: 30 }, controller.signal)
      .then(data => { if (current === sequence.current && !controller.signal.aborted) setResult(data); })
      .catch(err => { if (!controller.signal.aborted && current === sequence.current) setError(benefitError(err)); })
      .finally(() => { if (!controller.signal.aborted && current === sequence.current) setLoading(false); });
    return () => controller.abort();
  }, [token, rawPhone, page]);
  const customer = token && !rawPhone ? result?.customer : null;
  const history = result?.History || [];
  return <BenefitsLayout title="Tra cứu điểm tích lũy" description="Điểm hiện có và lịch sử tích điểm của bạn." error={error || (!token || rawPhone ? "Vui lòng mở liên kết tra cứu hợp lệ từ Zalo." : "")} publicView token={token}>
    {loading && <p role="status">Đang tải điểm tích lũy…</p>}
    {customer && <>
      <section className="benefits-panel"><h2>{customer.DisplayName || "Khách hàng"}</h2><p className="mb-0">Hạng: {customer.Membership}</p></section>
      <section className="benefits-metrics" aria-label="Số dư điểm">
        <article className="benefits-metric"><span>Điểm hiện có</span><strong>{benefitNumber(customer.DiemConlai ?? customer.DiemTichLuy)}</strong></article>
        <article className="benefits-metric"><span>Điểm đầu kỳ</span><strong>{benefitNumber(customer.DiemDauKy)}</strong></article>
        <article className="benefits-metric"><span>Tỷ lệ tích điểm hiện tại</span><strong>2%</strong></article>
      </section>
      {Number(customer.DiemConlai ?? customer.DiemTichLuy) < 0 && <div className="alert alert-warning">Số dư đang âm. Cần quản trị viên đối soát trước khi tiếp tục tiêu điểm.</div>}
      <section className="benefits-panel"><h2>Lịch sử bill và điểm</h2>
        <div className="table-responsive"><table className="table"><thead><tr><th>Ngày</th><th>Điểm cộng</th><th>Điểm tiêu</th></tr></thead>
          <tbody>{history.map((row, index) => <tr key={`${row.NgayGD}:${index}`}><td>{benefitDate(row.NgayGD)}</td><td>{benefitNumber(row.DiemDuocCong)}</td><td>{benefitNumber(row.DiemTieu)}</td></tr>)}</tbody></table></div>
        {!history.length && <p className="benefits-empty">Chưa có bill trong kỳ tra cứu.</p>}
        <BenefitPager page={page} onPage={setPage} hasNext={history.length === 30} busy={loading} />
      </section>
    </>}
  </BenefitsLayout>;
}
